import React, { useCallback } from 'react'
import styled from 'styled-components'

import UpdateItemOrTripDatesModal from './UpdateItemOrTripDatesModal'
import { useItemOutsideOfTripDates } from './utils'

import SolidExclamationTriangleIcon from 'LuxKit/Icons/solid/SolidExclamationTriangleIcon'
import Tooltip from 'LuxKit/Tooltip'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'
import { TripItem } from 'tripPlanner/types/tripItem'
import Clickable from 'components/Common/Clickable'

const FlexClickable = styled(Clickable)`
  display: flex;
`

interface Props {
  item: TripItem
  changeItemDates: () => void
}
export default function OutsideTripDatesIcon({ item, changeItemDates }: Props) {
  const openModal = useOpenModal()
  const updateItemOrTripDates = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      openModal(UpdateItemOrTripDatesModal, {
        item: item as TripItem & { startDate: moment.Moment },
        changeItemDates,
      })
      e.stopPropagation()
    },
    [changeItemDates, item, openModal],
  )

  const isItemOutsideOfTripDates: boolean = useItemOutsideOfTripDates(item)
  if (!isItemOutsideOfTripDates) return null

  return (
    <Tooltip description="Click here to view date conflict">
      <FlexClickable onClick={updateItemOrTripDates}>
        <SolidExclamationTriangleIcon size="S" colour="warning" />
      </FlexClickable>
    </Tooltip>
  )
}
